export enum SubscriptionRequestType {
   change = 'Change',
   cancel = 'Cancel',
   freeze = 'Freeze',
}
